type Listener = (data?: unknown) => void;

class EventEmitterService {
    private listeners: Record<string, Listener[]> = {};

    add(event: string, callback: Listener) {
        this.listeners[event] = this.listeners[event] ?? [];
        this.listeners[event].push(callback);
    }

    remove(event: string, callback: Listener) {
        this.listeners[event] = this.listeners[event]?.filter((cb) => cb !== callback) ?? [];
    }

    emit(event: string, data?: Record<string, unknown>) {
        this.listeners[event]?.forEach((cb) => cb(data));
    }
}

const EventEmitter = new EventEmitterService();
export default EventEmitter;
